module.exports = __webpack_public_path__ + "static/media/Nexity-Bold.64da7da6.ttf";